import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, getFileDownloadHeaders, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { downloadFile } from "../../../helpers/utils/FileUtils";
import { getFileName, serialize, showToast } from "../../../helpers/utils/Utils";

export const CustomerPricingApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchCustomerPricing: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/customer-pricing?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['customerPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCustomerPricingById: build.query({
            query: (regionId) => {
                return {
                    url: `/partner-pricings/${regionId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createCustomerPricing: build.mutation({
            query: ({ requestBody, id }) => {
                return {
                    url: `/ajax/create-customer-pricing`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['customerPricing'],
            async onQueryStarted({ id }, { queryFulfilled }) {
                const action = id ? "Updated" : "Created";
                await handleQueryErrorAndSuccess(queryFulfilled, action, "Customer Pricing");
            },
        }),

        updateCustomerPricing: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update-customer-pricings/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['customerPricing', 'customerPricingById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Customer Pricing");
            },
        }),

        deleteCustomerPricingById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-by-customer-pricing-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['customerPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Customer Pricing");
            },
        }),

        exportCustomerPricingData: build.query({
            query: (query) => {
                return {
                    url: `/export/customer-pricing`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => Promise<Blob> }) => {
                        const blob = await response.blob();
                        if (blob.size > 0) {
                            downloadFile(blob, getFileName("CustomerPricing"));
                            return { success: true };
                        } else {
                            showToast("No data found.");
                            return { success: false, message: "No data found." };
                        }
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    })
})

export const {
    useLazySearchCustomerPricingQuery,
    useCreateCustomerPricingMutation,
    useDeleteCustomerPricingByIdMutation,
    useLazyExportCustomerPricingDataQuery,
    useUpdateCustomerPricingMutation
} = CustomerPricingApi